import axios from 'axios'
import { BLOQUEAR_AGENCIA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default (idAgencia, idEmpresa) => dispach =>
  axios.get(`${URL}/agencia/${idAgencia}/empresa/${idEmpresa}/bloquear`,SLOW_REQUEST_CONFIG)
    .then( reponse => dispach({
      type: BLOQUEAR_AGENCIA,
      payload: reponse
    }));
